module.exports = __webpack_public_path__ + "d8304718e402ad7ce477b19995e50eb6.glb";